import {Platform} from 'react-native';

export const AVATAR_STORAGE_KEY = 'view.avatwinAvatar';

// Ava-Twin avatar the player saved, as reported by Unity (`avatwin_saved|id|skin|m|f`),
// or null when they have not created one yet. Web only: browser localStorage.
export const getSavedAvatarRecord = () => {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage?.getItem(AVATAR_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.avatarId) return null;
    return parsed;
  } catch (_) {
    return null;
  }
};

export const hasSavedAvatar = () => getSavedAvatarRecord() !== null;
